
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/versions/[model]",
      function () {
        return require("private-next-pages/auto-parts/versions/[model].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/versions/[model]"])
      });
    }
  